import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import _ from 'lodash';

@Component({
  selector: 'smart-table',
  templateUrl: './smart-table.component.html',
  styleUrls: ['./smart-table.component.scss'],
})
export class SmartTableComponent implements OnChanges {
  @Input() title?: string;
  @Input() settings: any;
  @Input() source: any = [];
  finalSettings: any;

  defaultSettings = {
    actions: false,
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.settings?.currentValue) {
      this.finalSettings = {
        ...this.settings,
        ...this.defaultSettings,
        columns: Object.fromEntries(
          Object.entries(this.settings?.columns).map(([key, value]) => [
            key,
            { ...(value as Object), filter: { enabled: false} }
          ]))
      };
    }
  }

  constructor() { }
}
